import React from 'react';
import classes from './SignatureModal.module.scss';

const ReviewContent = ({ name, fontStyles }) => {
  return (
    <div className={classes.reviewContentWrapper}>
      <span>
        LIFE Incorporated is a private, for-profit Developmental Disabilities
        Agency (DDA) and Residential Habilitation Agency providing a variety of
        quality services and supports to children and adults living with
        developmental disabilities in the State of Idaho. LIFE provides services
        under federal and state programs which require the submission of reports
        and information pursuant to law. The reports and information submitted
        by employees or contractors for LIFE through its software system will be
        relied upon by LIFE for its submissions to government entities and must
        be true and accurate under state and federal law. Information submitted
        by employees or contractors through LIFE’s software system is subject to
        both civil and criminal prosecution.
      </span>
      <span>
        I, the undersigned employee or contractor, understand and certify that
        my submissions of information to LIFE, including through its software
        system, will be true and accurate to the best of my knowledge,
        information and belief and that a violation of this requirement could
        include discipline up to and including termination and civil and
        criminal prosecution.
      </span>
      <div className={classes.signedSample}>
        <div>
          <div className={classes.sampleSignedText}>
            <span style={fontStyles}>{name}</span>
          </div>
        </div>
        <span>Name and signature of the employee</span>
      </div>
      <span>
        To be added to the software system on page for submission of information
      </span>
      <span>
        *By clicking <b>Accept</b> you agree to the terms in this document & the
        created signature will be inserted on your behalf.
      </span>
    </div>
  );
};

export default ReviewContent;
